import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { linkClasses, Link as Link$1 } from '@mui/material';
import { archerConstants } from '../../utils/themeProvider.js';
var _excluded = ["children", "disabled", "color", "component", "className", "sx"];
var styles = {
  linkRoot: {
    cursor: 'pointer',
    '&:hover': {
      outline: 'none',
      textDecoration: 'underline'
    },
    '&:focus': {
      outline: 'none',
      textDecoration: 'underline'
    }
  },
  linkRootDisabled: _defineProperty({
    pointerEvents: 'none',
    color: 'text.disabled'
  }, "&.".concat(linkClasses['underlineAlways']), {
    textDecorationColor: archerConstants.archerDisabled
  })
};

var Link = function Link(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      color = _ref.color,
      component = _ref.component,
      className = _ref.className,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var linkRoot = styles.linkRoot,
      linkRootDisabled = styles.linkRootDisabled;
  return /*#__PURE__*/React.createElement(Link$1, _extends({
    sx: [disabled ? linkRootDisabled : linkRoot, sx],
    color: color,
    component: component
  }, rest, {
    className: className ? className : '',
    tabIndex: 0
  }), children);
};

Link.displayName = 'Link';
export { Link };